<template>
  <div style="padding-top: 150px">
    <mynav></mynav>
    <div class="banner">
      <div class="am-g">
        <div>
          <img
            :src="coverurl"
            alt=""
            id="rec-banner"
            class="am-img-responsive banner-news"
          />
        </div>
      </div>
    </div>
    <div class="aboutus-box">
      <ul class="news-ul am-show-lg-only">
        <div class="aboutus-line"></div>
        <li
          @click="type = 0"
          :class="type == 0 ? 'li-img' : 'news-li'"
          id="my1"
        >
          <a href="#about1">关于我们</a>
        </li>
        <li
          @click="type = 1"
          :class="type == 1 ? 'li-img' : 'news-li'"
          id="my2"
        >
          <a href="#about2">资质荣誉</a>
        </li>
        <li
          @click="type = 2"
          :class="type == 2 ? 'li-img' : 'news-li'"
          id="my3"
        >
          <a href="#about3">合作伙伴</a>
        </li>
        <li
          @click="type = 3"
          :class="type == 3 ? 'li-img' : 'news-li'"
          id="my4"
        >
          <a href="#about4">公司客户</a>
        </li>
        <li
          @click="type = 4"
          :class="type == 4 ? 'li-img' : 'news-li'"
          id="my5"
        >
          <a href="#about5">联系我们</a>
        </li>
      </ul>
      <div class="aboutus-main" id="my-scrollspy1">
        <div id="about1" class="aboutus-target"></div>
        <h1 class="h-title">墣锦介绍</h1>
        <div class="we-hr">
          <hr style="height: 1px; border: none; border-top: 1px solid black" />
        </div>
        <div
          class="am-container aboutus-art"
          id="my-scrollspy1"
          data-am-scrollspy="{animation: 'fade'}"
        >
          <div v-for="(item, index) in companyList" :key="index">
            <img :src="item.logo" alt="" max-width="100%" />
            <div v-html="item.introduction"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="aboutus-box">
      <div class="aboutus-main">
        <div id="about2" class="aboutus-target"></div>
        <h1 class="h-title">资质荣誉</h1>
        <div class="we-hr">
          <hr style="height: 1px; border: none; border-top: 1px solid black" />
        </div>
        <div
          class="am-container am-g aboutus-art"
          id="my-scrollspy2"
          data-am-scrollspy="{animation: 'fade'}"
        >
          <div class="am-u-lg-12">
            <div style="display: flex; flex-wrap: wrap">
              <div
                class="am-u-lg-3 am-u-md-6 am-u-sm-12 am-u-end"
                style="margin: 30px 0"
                v-for="(item, index) in honorList"
                :key="index"
              >
                <img
                  :src="item.url"
                  alt=""
                  class="am-img-responsive"
                  style="margin: 0 auto"
                />
                <p class="honor-p">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="aboutus-box">
      <div class="aboutus-main">
        <div id="about3" class="aboutus-target"></div>
        <h1 class="h-title">合作伙伴</h1>
        <div class="we-hr">
          <hr style="height: 1px; border: none; border-top: 1px solid black" />
        </div>
        <div
          class="am-container am-g aboutus-art"
          id="my-scrollspy3"
          data-am-scrollspy="{animation: 'fade'}"
        >
          <div class="am-u-lg-12">
            <div style="display: flex; flex-wrap: wrap">
              <div
                class="am-u-lg-3 am-u-md-6 am-u-sm-6 am-u-end"
                style="margin: 30px 0"
                v-for="(item, index) in cooperateList"
                :key="index"
              >
                <img :src="item.url" class="am-img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="aboutus-box">
      <div class="aboutus-main">
        <div id="about4" class="aboutus-target"></div>
        <h1 class="h-title">公司客户</h1>
        <div class="we-hr">
          <hr style="height: 1px; border: none; border-top: 1px solid black" />
        </div>
        <div
          class="am-container am-g aboutus-art"
          id="my-scrollspy3"
          data-am-scrollspy="{animation: 'fade'}"
        >
          <div class="am-u-lg-12">
            <div style="display: flex; flex-wrap: wrap">
              <div
                class="am-u-lg-3 am-u-md-6 am-u-sm-6 am-u-end"
                style="margin: 30px 0"
                v-for="(item, index) in customerList"
                :key="index"
              >
                <img :src="item.url" class="am-img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="aboutus-box">
      <div class="aboutus-main abouts-lxwm">
        <div id="about5" class="aboutus-target"></div>
        <div style="float: left">
          <h1 class="h-title">联系我们</h1>
          <div class="we-hr">
            <hr
              style="height: 1px; border: none; border-top: 1px solid black"
            />
          </div>
          <div
            class="am-container aboutus-art"
            id="my-scrollspy4"
            data-am-scrollspy="{animation: 'fade'}"
          >
            <div class="am-u-lg-12">
              <div class="am-g">
                <div class="am-u-lg-4 am-u-md-8 am-u-sm-12 am-u-end">
                  <h3 class="aboutus-h3">海南墣锦环境科技股份有限公司</h3>
                  <h3 class="aboutus-h3">
                    联系我们：<br /><span class="am-icon-envelope"
                      >&nbsp;pujinhj@pujinhj.com</span
                    >
                  </h3>
                  <h3 class="aboutus-h3-sp">
                    <span class="am-icon-phone">&nbsp;0898-68501460</span>
                  </h3>
                  <h3 class="aboutus-h3">
                    地址：&nbsp;海南省海口市龙华区珠江广场帝豪大厦10层、12A层
                  </h3>
                </div>
                <div class="am-u-lg-4 am-u-md-8 am-u-sm-12 am-u-end">
                  <h3 class="aboutus-h3">上海墣锦环保科技有限公司</h3>
                  <h3 class="aboutus-h3">
                    联系我们：<br /><span class="am-icon-envelope"
                      >&nbsp;sam.song@pujinhj.com</span
                    >
                  </h3>
                  <h3 class="aboutus-h3-sp">
                    <span class="am-icon-phone">&nbsp;18601797996</span>
                  </h3>
                  <h3 class="aboutus-h3">
                    地址：&nbsp;上海市闵行区朱行路15号<br />1栋318室
                  </h3>
                </div>
                <div class="am-u-lg-4 am-u-md-8 am-u-sm-12 am-u-end">
                  <h3 class="aboutus-h3">四川墣锦净土科技有限公司</h3>
                  <h3 class="aboutus-h3">
                    联系我们：<br /><span class="am-icon-envelope"
                      >&nbsp;bo.feng@pujinhj.com</span
                    >
                  </h3>
                  <h3 class="aboutus-h3-sp">
                    <span class="am-icon-phone">&nbsp;028-85217079</span>
                  </h3>
                  <h3 class="aboutus-h3">
                    地址：&nbsp;四川省成都市高新区蜀锦路88号新中泰国际大厦701-702室
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="clear: both"></div>
    <myfooter></myfooter>
  </div>
</template>
<script>
import mynav from "../../components/nav.vue";
import myfooter from "../../components/footer.vue";
import "../../assets/css/amazeui.min.css";
import "../../assets/css/amazeui.css";
import "../../assets/css/app.css";
import "../../assets/css/header-footer.css";
export default {
  data() {
    return {
      coverurl:"",
      honorList: "",
      cooperateList: "",
      customerList: "",
      companyList: "",
      type: "0",
      lab: "",
    };
  },
  components: {
    mynav,
    myfooter,
  },
  watch: {
    $route() {
      this.myload();
    },
  },
  created() {
    this.myload();
  },
  mounted() {
    document.addEventListener("scroll", () => {
      var scrollDistance =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (document.getElementsByClassName("aboutus-box")[0]) {
        let list = [
          document.getElementsByClassName("aboutus-box")[0].offsetTop,
          document.getElementsByClassName("aboutus-box")[1].offsetTop,
          document.getElementsByClassName("aboutus-box")[2].offsetTop,
          document.getElementsByClassName("aboutus-box")[3].offsetTop,
          document.getElementsByClassName("aboutus-box")[4].offsetTop,
        ];
        let myindex = 0;
        for (const index in list) {
          if (list[index] < scrollDistance) {
            myindex = index;
          }
        }
        this.type = myindex;
      }
      if (document.getElementsByClassName("news-ul")[0]) {
        if (scrollDistance >= 583) {
          // 触发的位置
          document.getElementsByClassName("news-ul")[0].style.cssText =
            "position:fixed;top:60px;";
        } else {
          document.getElementsByClassName("news-ul")[0].style.cssText =
            "position:static;";
        }
      }
    });
  },
  methods: {
    myload() {
      this.lab = this.$route.query.lab || "ALL";
      this.$axios.get(`/front/getFrontPhone?type=about`).then((res) => {
        this.coverurl = res.data.url;
      });
      this.$axios
        .get(`/front/getFrontAboutList?type=customer&lab=${this.lab}`)
        .then((res) => {
          this.companyList = res.data;
        });
      this.$axios
        .get(`/front/getFrontAboutPhoto?type=honor&lab=${this.lab}`)
        .then((res) => {
          this.honorList = res.data;
        });
      this.$axios
        .get(`/front/getFrontAboutPhoto?type=cooperate&lab=${this.lab}`)
        .then((res) => {
          this.cooperateList = res.data;
        });
      this.$axios
        .get(`/front/getFrontAboutPhoto?type=customer&lab=${this.lab}`)
        .then((res) => {
          this.customerList = res.data;
        });
    },
  },
};
</script>
<style scoped>
.aboutus-box {
  max-width: 1200px;
  margin: 0 auto;
  clear: both;
}
.aboutus-main {
  max-width: 1000px;
  float: right;
  margin: 50px auto;
  background: white;
}
.aboutus-art {
  margin: 30px auto;
}
.news-ul {
  margin-top: -85px;
  float: left;
  list-style: none;

  z-index: 9999;
}
.news-li {
  margin: 20px 0;
  padding-left: 20px;
  background: url("../../assets/i/backline.png") 0 no-repeat;
}
.news-li > a {
  color: #7a7a7a;
}
.li-img {
  width: 85px;
  margin: 25px 0 25px 10px;
  padding-left: 13px;
  background: url("../../assets/i/timeframe.png") 0 no-repeat;
  background-size: 100%;
}
.li-img > a {
  color: #fff;
}

.aboutus-target {
  position: relative;
  top: -100px;
}
.aboutus-line {
  height: 250px;
  width: 2px;
  background: skyblue;
  position: relative;
  top: 250px;
  left: 5px;
  z-index: -1;
}
.abouts-lxwm {
  width: 83%;
}
.we-hr {
  width: 1000px;
  overflow: hidden;
}
.h-title {
  border-left: 5px solid #0168ad;
  text-indent: 8px;
}
.honor-p {
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: #eee;
  margin: 0 !important;
}
@media only screen and (max-width: 640px) {
  .h-title {
    border-left: 0 !important;
    text-indent: 0 !important;
  }
}
</style>
